'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

import * as InputCheck from '../../../utils/input_check';

import toPrice from '../../../utils/price';

class Product extends Marionette.View {

    ui() {
        let self = this;

        return {
            'buy': self.getOption('buy') || '.js-product-buy',
            'count': self.getOption('count') || '.js-product-count',
            'summ': self.getOption('summ') || '.js-product-summ',
            'delete': self.getOption('delete') || '.js-product-delete'
        };
    }
    regions() {
        return {
            'buy': '@ui.buy',
            'count': '@ui.count',
            'summ': '@ui.summ',
            'delete': '@ui.delete'
        };
    }
    childViewEvents() {
        return {
            'addToBasket:view': 'addToBasket',
            'removeFromBasket:view': 'removeFromBasket'
        };
    }
    modelEvents(){
        return {
            'change:is_in_basket': '_checkProductBasketState',
            'destroy': 'remove',
        };
    }
    initialize() {
        let self = this;

        // super.initialize(...arguments);
        self.template =  false;

        let product_id = self.$el.data('prodId');
        let by_weight = self.$el.data('byWeight');
        let price = self.$el.data('price');
        let count = self.$el.data('count');
        let is_in_basket = self.$el.data('inBasket');

        self.model.set({
            product_id: product_id,
            by_weight: by_weight,
            price: price,
            count: count,
            is_in_basket: is_in_basket,
            can_add_to_basket: true,
        }, { silent: true });
        // ((count > 0) ? true : false)

        var $buy = self.getUI('buy');
        self.showChildView('buy', new ProductButton({ el: $buy.find('button'),
                                                      model: self.model }));
        self.showChildView('count', new ProductCount({ model: self.model }));
        self.showChildView('summ', new ProductSumm({ model: self.model }));
        self.showChildView('delete', new ProductDelete({ model: self.model }));

        if (self.isRendered()) {
            self.triggerMethod('ready');
        }
    }
    onReady(){
        let self = this;
        self._checkProductBasketState();
        self.model.trigger('is:ready');
    }
    addToBasket() {
        let self = this;
        if((self.model.get('count') == 0) && (!self.model.get('is_in_basket'))){
            self.model.set('count', 1);
            self.getChildView('count').setCount('count');
        }
        self.model.addToBasket();
    }
    removeFromBasket() {
        let self = this;
        self.model.removeFromBasket();
    }
    _checkProductBasketState(){
        let self = this;

        if(self.model.get('is_in_basket')){
            self.$el.addClass('is-in-basket');
        }else{
            self.$el.removeClass('is-in-basket');
        }
    }
}

class ProductButton extends Marionette.View {
    template(){
        return false;
    }
    events() {
        return {
            'click': '_addToBasket',
        };
    }
    modelEvents() {
        return {
            // 'change:can_add_to_basket': '_checkEnabledState',
            'change:is_in_basket': '_checkInBasketState',
            'is:ready': '_onReady'
        };
    }
    _onReady() {
        let self = this;
        // self._checkEnabledState();
        self._checkInBasketState();
    }
    _addToBasket(){
        let self = this;
        // if(self.model.get('can_add_to_basket')){
        self.triggerMethod('addToBasket:view');

        if (!self.$el.closest('.js-product-bask').length) {
            $('.js-product-bask').remove();
        }
        let basketLink = '<a class="products__basket js-product-bask" href="/order/">Перейти в корзину</a>'; //27.03.2020
        $(basketLink).insertAfter(self.$el); //27.03.2020
        // }
    }
    _checkEnabledState() {
        let self = this;

        if(self.model.get('can_add_to_basket')){
            self.$el.removeClass('is-disabled');
        } else {
            self.$el.addClass('is-disabled');
        }
    }
    _checkInBasketState() {
        let self = this;
        if(self.model.get('is_in_basket')){
            self.$el.text('Изменить');
        }else{
            self.$el.text('Заказать');
        }
    }
}

class ProductDelete extends Marionette.View {
    tagName() {
        return 'span';
    }
    events() {
        return {
            'click': '_removeFromBasket',
        };
    }
    modelEvents() {
        return {
            'change:is_in_basket': '_checkState',
            'is:ready': '_onReady'
        };
    }
    _onReady() {
        let self = this;
        self._checkState();
    }
    render() {
        let self = this;
        self.$el.addClass('btn m--delete')
            .attr('title', 'Убрать из корзины')
            .text('Убрать из корзины');

        return self;
    }
    _removeFromBasket(){
        let self = this;
        if(self.model.get('is_in_basket')){
            self.triggerMethod('removeFromBasket:view');
        }
    }
    _checkState() {
        let self = this;
        if(self.model.get('is_in_basket')){
            self.$el.show();
        }else{
            self.$el.hide();
        }
    }
}

class ProductCount extends Marionette.View {
    getTemplate(){
        let self = this;
        if(self.model.get('by_weight')){
            return _.template('<input type="number" value="<%- count %>" min="0" step="any" />');
        }else{
            return _.template('<input type="number" value="<%- count %>" min="0" step="1" />');
        }
    }
    ui() {
        return {
            'input': 'input'
        };
    }
    modelEvents() {
        return {
            'is:removed': 'render',
            'on:value:changed' : 'setCount'
        };
    }
    events() {
        return {
            'change @ui.input': 'changeCount',
        };
    }
    onRender() {
        let self = this;
        self._detectType();

        let input = self.getUI('input');
        if(self.model.get('by_weight')){
            input
                .on('keydown', function(e){ return InputCheck.floatInput(this, e); })
                .on('change', function(e){
                    let vl = parseFloat(this.value, 10);
                    if(vl < 0){
                        vl *= -1;
                    }
                    this.value = vl;
                });
        }else{
            input
                .on('keydown', function(e){ return InputCheck.integerInput(this, e); })
                .inputarrow({
                    min: 0,
                    no_max: true,
                    step: self.model.get('step')
                });
        }
    }
    changeCount(){
        let self = this;
        let count = self.getCount();
        self.model.set('count', count);
    }
    getCount(){
        let self = this;
        let $input = self.getUI('input');
        return $input.val();
    }
    setCount(model_field){
        let self = this;
        let field = 'count';
        if(model_field === field){
            let $input = self.getUI('input');
            $input.val(self.model.get(field));
        }
    }
    _detectType() {
        let self = this;
        self.$el.removeClass('simple-input')
                .removeClass('arrow-input');

        if(self.model.get('by_weight')){
            self.$el.addClass('simple-input');
        }else{
            self.$el.addClass('arrow-input');
        }
    }
}

class ProductSumm extends Marionette.View {
    tagName() {
        return 'span';
    }
    modelEvents() {
        return {
            'change:summ': 'render',
        };
    }
    initialize() {
        let self = this;
        self.$el.addClass('price');
    }
    render() {
        let self = this;
        self.$el.html(toPrice({ price: self.model.get('summ'),
                                kop: true,
                                sign: 'р' }));
        return self;
    }
}

export {
    Product,
    ProductButton,
    ProductDelete,
    ProductCount,
    ProductSumm
};
